import { useCallback } from "react";
import { useAuth } from "@clerk/react";
import { api } from "@/lib/api";

export function useAdminApi() {
  const { getToken } = useAuth();
  return useCallback(async (method, url, data, config = {}) => {
    const token = await getToken();
    return api.request({ method, url, data, ...config, headers: { Authorization: `Bearer ${token}`, ...(config.headers || {}) } });
  }, [getToken]);
}
